import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-page-bar',
  templateUrl: './page-bar.component.html',
  styleUrls: ['./page-bar.component.css']
})
export class PageBarComponent implements OnInit {

  constructor(
    private location: Location,
  ) {
  }

  ngOnInit(): void {
  }

  back(): void {
    this.location.back();
  }

}
